import React, { Component } from "react";
import { CircularLoader } from "@plum-xoxo/admin-dsm";

class Loader extends Component {
  render() {
    const { message = "" } = this.props;
    return <CircularLoader size="lg" vertical center content={message} />;
  }
}

export default Loader;
